import {
  // createAction,
  handleActions
} from "redux-actions";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_TOP_PERFORMERS_SUCCESS,
  FETCH_POOR_PERFORMERS_SUCCESS,
  FETCH_CLASS_BY_TYPE_SUCCESS,
  FETCH_VISITS_BY_TYPE_SUCCESS,
  SET_CLASS_TYPES_CHECKED,
  ADD_CLASS_CHART_SUCCESS,
  REMOVE_CLASS_CATEGORY,
  REMOVE_CLASS_CATEGORY_SUCCESS,
  FETCH_ALL_CLASSES_BY_TYPE_SUCCESS
} from "../sagas/attendance/attendance";
// Name Spaced Action Types
export const actions = {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_TOP_PERFORMERS_SUCCESS,
  FETCH_POOR_PERFORMERS_SUCCESS,
  FETCH_CLASS_BY_TYPE_SUCCESS,
  FETCH_VISITS_BY_TYPE_SUCCESS,
  SET_CLASS_TYPES_CHECKED,
  ADD_CLASS_CHART_SUCCESS,
  REMOVE_CLASS_CATEGORY,
  REMOVE_CLASS_CATEGORY_SUCCESS,
  FETCH_ALL_CLASSES_BY_TYPE_SUCCESS
};

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
export const actionCreators = {};

export function getTypeValues(data) {
  let types = [];
  data.map(item => {
    types.push(item.id);
  });
  // console.log(data);
  return types;
}

export const initialState = {
  currentUser: {},
  topPerformers: [],
  poorPerformers: [],
  classByTypeAttendance: [],
  allClassesByType: [],
  visitsByType: {
    percentageOfNewVisits: 0
  },
  classByTypeAttendanceChecked: {},
  classByTypeAttendanceCheckedMax: false,
  isLoading: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_TOP_PERFORMERS_SUCCESS]: (state, action) => ({
      ...state,
      topPerformers: action.payload.topPerformers || state.topPerformers
    }),
    [FETCH_POOR_PERFORMERS_SUCCESS]: (state, action) => ({
      ...state,
      poorPerformers: action.payload.poorPerformers || state.poorPerformers
    }),
    [FETCH_CLASS_BY_TYPE_SUCCESS]: (state, action) => ({
      ...state,
      classByTypeAttendance: action.payload.classByTypeAttendance || state.classByTypeAttendance,
      classByTypeAttendanceChecked: getTypeValues(action.payload.classByTypeAttendance) || state.classByTypeAttendanceChecked
    }),
    [FETCH_ALL_CLASSES_BY_TYPE_SUCCESS]: (state, action) => ({
      ...state,
      allClassesByType: action.payload.allClassesByType || state.allClassesByType
    }),
    [FETCH_VISITS_BY_TYPE_SUCCESS]: (state, action) => ({
      ...state,
      visitsByType: action.payload.visitsByType || state.visitsByType
    }),
    [SET_CLASS_TYPES_CHECKED]: (state, action) => ({
      ...state,
      classByTypeAttendanceChecked: action.payload.filtered || state.classByTypeAttendanceChecked,
      classByTypeAttendanceCheckedMax: action.payload.maxChecked
    }),
    [ADD_CLASS_CHART_SUCCESS]: (state, action) => ({
      ...state,
      classByTypeAttendance: action.payload.classByTypeAttendance || state.classByTypeAttendance
    }),
    [REMOVE_CLASS_CATEGORY]: (state, action) => ({
      ...state,
      classByTypeAttendance: state.classByTypeAttendance.filter(rev => rev.id !== action.payload.id)
    }),
    [REMOVE_CLASS_CATEGORY_SUCCESS]: (state, action) => ({
      ...state,
      classByTypeAttendance: action.payload.classByTypeAttendance || state.classByTypeAttendance,
      classByTypeAttendanceChecked: getTypeValues(action.payload.classByTypeAttendance) || state.classByTypeAttendanceChecked,
      classByTypeAttendanceCheckedMax: false
    })
  },
  initialState
);
